import { render, staticRenderFns } from "./EmailIcon.vue?vue&type=template&id=513af007&"
var script = {}
import style0 from "./EmailIcon.vue?vue&type=style&index=0&id=513af007&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports